<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import {useEmailLogs} from "@/composables/email-logs/useEmailLogs";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";

const {modalEmail, emailHtml, emailHtmlError, closeModal, getEmailHtml} = useEmailLogs();

const {mutate, isPending} = getEmailHtml();

mutate(modalEmail.value.id);
</script>

<template>
  <BaseModal
    modal-class="tw-w-[90vw] tw-max-w-[1312px] tw-max-h-[80vh]"
    @close="closeModal"
  >
    <div class="tw-flex tw-flex-col tw-gap-y-4">
      <ModalHeader>
        <ModalSubText>
          <div class="tw-flex tw-flex-col tw-gap-2">
            <span class="tw-truncate">
              <strong>From:</strong> {{ modalEmail.from }}
            </span>
            <span class="tw-truncate">
              <strong>To:</strong> {{ modalEmail.recipients.join(', ') }}
            </span>
            <span class="tw-truncate">
              <strong>Subject:</strong> {{ modalEmail.subject }}
            </span>
          </div>
        </ModalSubText>
      </ModalHeader>

      <div
        v-if="isPending"
        class="tw-bg-white tw-p-8 tw-rounded-lg"
      >
        <LoadingBlock />
      </div>

      <iframe
        v-else-if="emailHtml"
        :srcdoc="emailHtml"
        class="tw-h-[50vh] tw-w-full"
        sandbox=""
      />

      <div
        v-else-if="emailHtmlError"
        class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-p-8 tw-text-2xl tw-text-neutral-900 tw-self-center"
      >
        <svg-vue
          icon="illustrations/sad-folders"
          class="tw-w-68"
        />
        There was an error loading the email content.
      </div>
    </div>
  </BaseModal>
</template>

